export default "https://cdn-static.gokick.com/assets/3c8eadbe8dc90fc8bfe5d2560afe7db765946837/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";